import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass, unref as _unref, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e944b3d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-full flex -gap-x-8" }
const _hoisted_2 = { class: "h-full flex flex-col justify-between" }
const _hoisted_3 = { class: "flex justify-center py-2" }
const _hoisted_4 = {
  class: "flex flex-col justify-start -gap-y-4",
  style: {"height":"calc(100% - 7rem)"}
}
const _hoisted_5 = { class: "flex items-center -gap-x-2 pl-1" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "flex justify-center py-2" }
const _hoisted_8 = { class: "grid content-between h-full" }
const _hoisted_9 = { class: "w-2/5" }
const _hoisted_10 = { class: "text-2xl" }
const _hoisted_11 = { class: "mt-4 text-gray-500" }
const _hoisted_12 = { class: "w-full h-full flex justify-center items-center text-white text-base horizontal-gradient" }

import { reactive } from 'vue';
import { PageWithChildrenDto } from 'stores/modules/page';
import tmpl from 'src/utils/tmpl';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'SvProjectTabs',
  props: {
    pages: {}
  },
  setup(__props: any) {

const { t } = useI18n();

const props = __props;

const state = reactive({
  tab: 0,
  start: 0,
  end: Math.min(props.pages.length - 1, 5),
});

const prev = () => {
  if (state.tab > state.start) {
    state.tab--;
  } else if (state.start > 0) {
    state.start--;
    state.end--;
    // if (state.tab > state.end) state.tab = state.end;
    if (state.tab === state.start + 1) state.tab--;
  }
};

const next = () => {
  if (state.tab < state.end) {
    state.tab++;
  } else if (state.end < props.pages.length - 1) {
    state.start++;
    state.end++;
    // if (state.tab < state.start) state.tab = state.start;
    if (state.tab === state.end - 1) state.tab++;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_q_tab_panel = _resolveComponent("q-tab-panel")!
  const _component_q_tab_panels = _resolveComponent("q-tab-panels")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_card, {
      class: "flex-none bg-transparent",
      style: {"min-width":"23rem"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_tabs, {
          modelValue: state.tab,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.tab) = $event)),
          "active-class": "horizontal-gradient-0.2",
          "indicator-color": "transparent",
          vertical: "",
          "no-caps": ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_q_btn, {
                  class: "text-xl hover:text-green-600",
                  icon: "mdi-menu-up",
                  flat: "",
                  "fab-mini": "",
                  "no-caps": "",
                  onClick: prev
                })
              ]),
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (page, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: page.id,
                    class: _normalizeClass(`mx-8 shadow shadow-gray-300 ${
                i < state.start || i > state.end ? 'hidden' : ''
              }`)
                  }, [
                    _createVNode(_component_q_tab, {
                      class: "flex justify-start",
                      name: i,
                      ripple: false,
                      "no-caps": ""
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          (page.icon)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                class: "w-6 h-6",
                                src: page.icon,
                                alt: "icon"
                              }, null, 8, _hoisted_6))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", null, _toDisplayString(page.title), 1)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["name"])
                  ], 2))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_q_btn, {
                  class: "text-xl hover:text-green-600",
                  icon: "mdi-menu-down",
                  flat: "",
                  "fab-mini": "",
                  "no-caps": "",
                  onClick: next
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_q_card, { class: "flex-1 bg-transparent" }, {
      default: _withCtx(() => [
        _createVNode(_component_q_tab_panels, {
          class: "h-full bg-transparent",
          modelValue: state.tab,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.tab) = $event)),
          animated: "",
          swipeable: "",
          vertical: "",
          "transition-prev": "jump-up",
          "transition-next": "jump-up"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (page, i) => {
              return (_openBlock(), _createBlock(_component_q_tab_panel, {
                key: page.id,
                class: "px-10 py-12",
                name: i,
                style: _normalizeStyle(`background: url('${page.image}') no-repeat bottom right; background-size: auto 100%; background-position: 70%`)
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, _toDisplayString(page.title), 1),
                      _createElementVNode("div", _hoisted_11, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((page.summary ?? '').split('\n'), (p, i) => {
                          return (_openBlock(), _createElementBlock("p", { key: i }, _toDisplayString(p), 1))
                        }), 128))
                      ]),
                      _createVNode(_component_router_link, {
                        class: "flex -gap-x-2 items-center mt-8 text-green-600",
                        to: _unref(tmpl)(page.url!, page)
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(_unref(t)('SvProjectTabs.more')), 1),
                          _createVNode(_component_q_icon, {
                            size: "20px",
                            name: "mdi-arrow-right-drop-circle-outline"
                          })
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]),
                    _createVNode(_component_q_btn, {
                      class: "w-40 h-11",
                      "no-caps": "",
                      square: "",
                      padding: "0",
                      to: "/about/contact"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(t)('SvProjectTabs.consult')), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 2
              }, 1032, ["name", "style"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    })
  ]))
}
}

})